class ProductTitle {
    constructor() {
        this.prodGridItemTitle = document.querySelectorAll('.product-grid-item__title');
        this.prodSingleTitle = document.querySelectorAll('.product__title');
        this.prodUpsellTitle = document.querySelectorAll('.product-upsell__title a');
    }

    init() {
        this.updateProdTitle(this.prodGridItemTitle);
        this.updateProdTitle(this.prodSingleTitle);
        this.updateProdTitle(this.prodUpsellTitle);
    }

    updateProdTitle(titles) {
        titles.forEach(title => {
            let hyphenIndex = title.innerText.indexOf('-');
            if(hyphenIndex !== -1) {
                const beforeHyphen = title.innerText.substring(0, hyphenIndex + 1).trim();
                const afterDash = title.innerText.substring(hyphenIndex + 1).trim();
                title.innerHTML = `<span class="prod__title">${beforeHyphen}</span> <span class="prod__title--highlight">${afterDash}</span>`;
            } else {
                title.innerHTML = `<span class="prod__title">${title.innerText}</span>`;
            }
        })
    }
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelectorAll('.product-grid-item').length > 0 || document.querySelector('.product-single')) {
        const productTitle = new ProductTitle();
        productTitle.init();
    }
});